export const mpesaErrors = {
  "INS-0": "Pagamento realizado com sucesso",
  "INS-5": "Pagamento cancelado pelo cliente",
  "INS-6": "A transaccao falhou",
  "INS-9": "Tempo de espera esgotado",
  "INS-10": "Transaccao duplicada",
  "INS-2006": "Saldo insuficiente",
  "INS-2051": "Numero M-Pesa invalido",
};

function procurarCodigoMpesa(valor) {
  if (!valor) return null;

  if (typeof valor === "string") {
    if (/saldo insuficiente|insufficient/i.test(valor)) return "INS-2006";
    return valor.match(/INS-\d+/)?.[0] || null;
  }

  if (typeof valor !== "object") return null;

  for (const item of Object.values(valor)) {
    const codigo = procurarCodigoMpesa(item);
    if (codigo) return codigo;
  }

  return null;
}

function procurarMensagemMpesa(valor) {
  if (!valor || typeof valor !== "object") return null;

  return (
    valor.output_ResponseDesc ||
    valor.output_ResponseDescription ||
    valor.responseDesc ||
    valor.responseDescription ||
    valor.Mensagem ||
    valor.mensagem ||
    valor.message ||
    null
  );
}

export function getMpesaFeedback(payload) {
  const data = payload?.response?.data || payload?.data || payload || {};
  const detalhes = data.Detalhes || data.detalhes || data;
  const code =
    detalhes.output_ResponseCode ||
    detalhes.responseCode ||
    data.output_ResponseCode ||
    data.responseCode ||
    procurarCodigoMpesa(data);

  const message =
    mpesaErrors[code] ||
    procurarMensagemMpesa(detalhes) ||
    procurarMensagemMpesa(data) ||
    "Nao foi possivel confirmar o pagamento. Tente novamente.";

  const isPending = code === "INS-9" || code === "PENDENTE" || data.estadoPagamento === "pendente";

  return {
    code: code || "ERRO",
    message,
    type: code === "INS-0" ? "success" : isPending ? "pending" : "error",
    amount:
      data.valorCobrado ??
      data.valorPago ??
      data.amount ??
      data.valor ??
      null,
    plan:
      data.plano ??
      data.profile ??
      data.profileusuario ??
      null,
    receiptId: data.reciboId ?? data.idRecibo ?? null,
    reference: data.referenciaPagamento ?? data.thirdparty_ref ?? null,
    paymentState: data.estadoPagamento ?? null,
    raw: data,
  };
}
